import React, { Component } from 'react'
import { Modal } from 'react-bootstrap'
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ViewWeekIcon from '@mui/icons-material/ViewWeek';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Switch from '@mui/material/Switch';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

Array.prototype.insert = function (index, item) {
    this.splice(index, 0, item);
};

var lastHiddenColArr = []
export default class ContaxtMenu extends Component {
    constructor(props) {
        super(props)
        this.state = {
            options: [], lastFreezedColumn: '', isOpenHiddenColList: false, hiddenColBackup: [], search: ''
            , allHiddenCols: [], isColFound: true, isShowAllDisabled: false, isHideAllDisabled: false
        }
        this.onListItemSelect = this.onListItemSelect.bind(this)
    }
    componentDidMount() {
        let arr = [
            {
                displayText: `Freeze up to column ${this.props.currentClickedColumn.toUpperCase()}`,
                category: 'freeze',
                icon: '',
                recid: 1,
                show: true
            },
            {
                displayText: `Unfreeze columns`,
                category: 'freeze',
                icon: '',
                recid: 2,
                show: false
            },
            {
                displayText: `Sort ${this.props.currentClickedColumn.toUpperCase()} by A to Z`,
                category: 'sort',
                icon: <ArrowUpwardIcon />,
                recid: 3,
                show: true
            },
            {
                displayText: `Sort ${this.props.currentClickedColumn.toUpperCase()} by Z to A`,
                category: 'sort',
                icon: <ArrowDownwardIcon />,
                recid: 4,
                show: true
            },
            {
                displayText: 'Reset Sort',
                category: 'sort',
                icon: <RotateLeftIcon />,
                recid: 5,
                show: false
            },
            {
                displayText: 'Hide Column',
                category: 'sort',
                icon: <VisibilityOffIcon />,
                recid: 6,
                show: true
            },
            {
                displayText: 'Show Hidden Column(s)',
                category: 'sort',
                icon: <VisibilityIcon />,
                recid: 7,
                show: false
            },
        ]

        const filter = (id, boolean) => {
            arr.forEach((el) => {
                if (el.recid == id) {
                    el.show = boolean
                }
            })
        }
        if (this.props.freezed) {
            filter(2, true)
        } else {
            filter(2, false)
        }

        if (this.props.sorted) {
            filter(5, true)
        } else {
            filter(5, false)
        }

        if (this.props.hiddenColumnsArr.length > 0) {
            filter(7, true)
        } else {
            filter(7, false)
        }

        this.setState({
            options: arr
        })



        // This code works for setting the array of all hidden columns

        let hide_arr = []
        for (const key of this.props.hiddenColumnsArr) {
            let obj = {
                colname: key,
                checked: true
            }
            hide_arr.push(obj)
        }
        this.setState({ allHiddenCols: hide_arr, hiddenColBackup: this.props.hiddenColumnsArr })
        lastHiddenColArr = hide_arr
    }
    onListItemSelect(list) {
        const returnCallback = (array, recid, list, boolean) => {

            array.forEach((el) => {
                if (el.recid == recid) {
                    el.show = boolean
                }
            })
            console.log(array)
            console.log(recid)
            this.setState({ options: array }, () => {
                if (recid == 2) {
                    this.props.onSelect(list, boolean)
                } else if (list.recid == 5) {
                    this.props.onSortChange('default', boolean)
                } else if (list.recid == 3 || list.recid == 4) {
                    let order = list.recid == 3 ? 'asc' : "desc"
                    console.log(order)
                    this.props.onSortChange(order, boolean)
                } else if (list.recid == 6) {
                    this.props.onHideColumn()
                } else if (list.recid == 7) {
                    // this.props.onShowColumn()
                    this.setState({ isOpenHiddenColList: true })
                }
            })
        }
        let arr = this.state.options
        if (list.recid == 1) {
            returnCallback(arr, 2, list, true)
        }
        if (list.recid == 2) {
            returnCallback(arr, 2, list, false)
        }
        if (list.recid == 3 || list.recid == 4) {
            returnCallback(arr, 5, list, true)
        }
        if (list.recid == 5) {
            returnCallback(arr, 5, list, false)
        }
        if (list.recid == 6) {
            returnCallback(arr, 7, list, true)
        }
        if (list.recid == 7) {
            returnCallback(arr, 7, list, true)
        }
        console.log(this.state.options)
    }
    onTitleSearch(e) {
        let value = e.target.value.toLowerCase()
        this.setState({ search: value })
        if (value == '') {
            if (lastHiddenColArr.length > 0) {
                this.setState({ allHiddenCols: lastHiddenColArr, isColFound: true })
            } else {
                this.setState({ isColFound: false })
            }
        } else {
            if ((lastHiddenColArr.filter((data) => data.colname.toLowerCase().includes(value)).length) > 0) {
                this.setState({ allHiddenCols: lastHiddenColArr.filter((data) => data.colname.toLowerCase().includes(value)), isColFound: true })
            } else {
                this.setState({ isColFound: false })
            }
        }
    }
    onShowAllColumns() {
        // This code works for setting the array of all hidden columns
        // console.log(this.state.hiddenColBackup)
        this.setState({ search: '' })
        let hide_arr = []
        for (const key of this.state.hiddenColBackup) {
            let obj = {
                colname: key,
                checked: false
            }
            hide_arr.push(obj)
        }
        lastHiddenColArr = hide_arr
        this.setState({ allHiddenCols: hide_arr, isShowAllDisabled: true, isHideAllDisabled: false }, () => this.props.onShowAllColumn())
    }
    onHideAllColumns() {
        // This code works for setting the array of all hidden columns
        this.setState({ search: '' })
        let hide_arr = []
        for (const key of this.state.hiddenColBackup) {
            let obj = {
                colname: key,
                checked: true
            }
            hide_arr.push(obj)
        }
        lastHiddenColArr = hide_arr
        this.setState({ allHiddenCols: hide_arr, isHideAllDisabled: true, isShowAllDisabled: false }, () => this.props.onHideAllColumn(this.state.hiddenColBackup))
        // this.props.onShowColumn()
    }
    render() {
        console.log(this.props)
        return (
            <>
                <Modal id="contaxtModal" size={"sm"} centered show={this.props} onHide={(e) => this.props.onHide && this.props.onHide(e)}>
                    <Modal.Body>
                        {
                            this.state.options.length > 0 ?
                                this.state.options.map((list, index) => {
                                    let divider = '';
                                    if (index != 0 && list.category != this.state.options[index - 1].category) {
                                        divider = '1px solid rgba(0,0,0,0.1)'
                                    }
                                    if (list.show) {
                                        return (
                                            <div key={index} style={{ borderTop: divider, display: "flex", justifyContent: "space-between" }} className='customContaxtMenu' onClick={(e) => this.props.onSelect && this.onListItemSelect(list)}>
                                                <div style={{ display: "flex" }}>
                                                    <div style={{ paddingRight: "10px" }}>
                                                        {list.icon}
                                                    </div>
                                                    <span>{list.displayText}</span>
                                                </div>
                                                {/* {
                                                    list.recid == 7 &&
                                                    <div>
                                                        <Tooltip title="Select Columns">
                                                            <IconButton onClick={(e) => {
                                                                e.stopPropagation()
                                                                console.log('jsldf')
                                                                this.setState({ isOpenHiddenColList: true })
                                                            }}>
                                                                <ViewWeekIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </div>
                                                } */}
                                            </div>
                                        )
                                    }
                                })
                                :
                                null
                        }

                    </Modal.Body>
                </Modal>
                <Modal size="sm" id={'hidden_col_modal'} centered animation={true} style={{ background: "rgba(0,0,0,0.5)" }} show={this.state.isOpenHiddenColList} onHide={() => this.setState({ isOpenHiddenColList: false })}> {/* backdrop="static" keyboard={false} */}
                    <Modal.Body style={{ padding: "0px" }}>
                        <div className="HiddenList">
                            <div className="list_filter from-group">
                                <label htmlFor="find_column">Find Column</label>
                                <input type="text" onChange={(e) => this.onTitleSearch(e)} value={this.state.search} placeholder='Column title' className='form-control' />
                            </div>
                            <div className="list">
                                <FormGroup>
                                    {
                                        this.state.isColFound ?
                                            this.state.allHiddenCols.length > 0 &&
                                            this.state.allHiddenCols.map((col, index) => {
                                                return (
                                                    <FormControlLabel key={index
                                                    } control={<Switch checked={col.checked} onChange={(e) => {
                                                        const arr = this.state.allHiddenCols.filter((newcol) => newcol.colname === col.colname)
                                                        console.log(arr)
                                                        arr[0].checked = e.target.checked
                                                        this.setState({ isRenderAgain: true }, () => {
                                                            // console.log(this.state.allHiddenCols)
                                                            if (e.target.checked) {
                                                                this.props.onColHide(col.colname)
                                                            } else {
                                                                this.props.onColShow(col.colname)
                                                            }
                                                        })
                                                    }} />} label={col.colname} />
                                                )
                                            })
                                            :
                                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: '100%', height: "inherit", minHeight: "10vh" }}>
                                                <h5 style={{ color: 'orange' }}>No Title Found!</h5>
                                            </div>
                                    }
                                </FormGroup>
                            </div>
                            <div className="footer_list">
                                <span className="hide_all" onClick={() => !this.state.isHideAllDisabled && this.onHideAllColumns()}>Hide All</span>
                                <span className="show_all" onClick={() => !this.state.isShowAllDisabled && this.onShowAllColumns()}>Show All</span>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </>
        )
    }
}





// Last changes made in contaxt menu & I was building that user can show
// and hide columns according to own choise